import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { addSpace, rescueHtml } from '../Components/Tools';


const Page11RestitutionInv = (props) =>
{
    const blue = '#069BD3'
    const smoothGrey = '#f4f4f4'

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    <img style={{width: 200}} src={Logo} />
                </div>

                <div style={{flex: 1}}></div>
                
                <div style={{margin: 25}}>
                    <p style={{color: blue, fontSize: 24}}>{rescueHtml(props.user.nom_organisme)}</p>
                </div>
            </div>

            <div style={{marginLeft: 25, borderBottom: '1px solid '+blue}}>
                <p style={{color: blue, fontSize: 26}}>{props.titre}</p>
            </div>


            {/* Container */}
            <div style={{flex: 1, marginLeft: 25, height: '70%'}}>
                <div style={{flex: 1, border: '1px solid '+blue, borderRadius: 2, marginTop: 25, marginRight: 25}}>
                    <div style={{flex: 1, backgroundColor: blue, color: 'white', display: 'flex'}}>

                        <div style={{flex: 3.5, textAlign: 'center'}}>
                            <p style={{fontSize: 13}}>Montants en €</p>
                        </div>

                        {props.annees !== null?
                        props.annees.map((an, j) =>
                        <div key={j} style={{flex: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                            <p style={{fontSize: 13}}>{an}</p>
                        </div>
                        ):null}

                    </div>

                    {props.restitution !== null?
                    props.restitution.map((line, i) => 
                    <div key={i} style={
                    line[0].chapitre === '1'?
                        {flex: 1, borderTop: '1px solid white', display: 'flex', backgroundColor: blue}
                        :
                        i%2?
                            {flex: 1, borderTop: '1px solid white', display: 'flex', backgroundColor: smoothGrey}
                        :
                            {flex: 1, borderTop: '1px solid white', display: 'flex'}
                    }>
                        <div style={{flex: 3.5, justifyContent: 'center'}}>
                            <p style={
                            line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                {fontSize: 13, paddingLeft: (line[0].indentation + 1)*2, color: blue, fontWeight: 'bold'}
                                :
                                line[0].chapitre === '1'?
                                    {fontSize: 13, paddingLeft: 2, color: 'white'}
                                :
                                    line[0].indentation === '2'?
                                        {fontSize: 10, paddingLeft: (line[0].indentation + 1)*2, fontStyle: 'italic'}
                                    :
                                        {fontSize: 11, paddingLeft: (line[0].indentation + 1)*2}
                            }>{line[0].intitule}</p>
                        </div>
                        
                        {line.map((col, l) =>
                        l !== 0?
                        <div key={l} style={{flex: 1, justifyContent: 'center', borderLeft: '1px solid white'}}>
                            {(() => {
                            const yearsCount = props.restitution.length - 1;
                            const rel = yearsCount - i; // 0 = dernière, 3 = 4ème depuis la fin

                            // Si c'est une COM ou EPCI ou de la M4 alors les 4 dernieres lignes s'affichent comme suit :
                            if (props.user.id_organisme_type == '1' || props.user.id_organisme_type == '2'
                                || props.user.nomen === 'M4' || props.user.nomen === 'M41' || props.user.nomen === 'M43' || props.user.nomen === 'M49') {
                                if (rel === 3) {
                                    return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1] * 100) / 100)} an(s)</p>;
                                }

                                if (rel === 1 || rel === 2) {
                                    return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1]), true)}%</p>;
                                }

                                if (rel === 0) {
                                    return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1]), true)} jour(s)</p>;
                                }
                                return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1]), true)}</p>;
                            }
                            // sinon si c'est un EPFL les 3 dernieres lignes s'affichent comme suit :
                            else if (props.user.id_organisme_type == '4') {

                                if (rel === 0 || rel === 1 || rel === 2) {
                                    return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1]))}%</p>;
                                }
                                return <p style={
                                line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120'?
                                    {fontSize: 13, textAlign: 'right', paddingRight: 2, color: blue, fontWeight: 'bold'}
                                :
                                    line[0].chapitre === '1'?
                                        {fontSize: 13, textAlign: 'right', paddingRight: 2, color: 'white'}
                                    :
                                        line[0].indentation === '2'?
                                            {fontSize: 10, textAlign: 'right', paddingRight: 2, fontStyle: 'italic'}
                                        :
                                            {fontSize: 11, textAlign: 'right', paddingRight: 2}
                                }>{col[1] == 0 ? 0 : addSpace(Math.round(col[1]), true)}</p>;
                            }

                        })()}
                        </div>
                        :null)}
                    </div>
                    )
                    :
                    <div style={{flex: 10, borderTop: '1px solid white', display: 'flex'}}></div>
                    }
                </div>
            </div>


            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
                <div style={{marginRight: 25}}>
                    <p style={{fontSize: 10}}>Page : {props.index}</p>
                </div>
            </div>
        </div>
    );
}

export default Page11RestitutionInv;